import {Component, ViewChild} from '@angular/core';
import {ClientService} from '../../pages/clients/clients.service';
import {ModalController} from '@ionic/angular';
import {PhotoService} from '../../providers/photo.service';
import {GlobalsService} from '../../globals.service';
import {ZendeskProvider} from '../../providers/zendesk.service';

@Component({
  selector: 'app-ticket-modal',
  templateUrl: './ticket-modal.component.html',
  styleUrls: ['./ticket-modal.component.scss'],
})
export class TicketModalComponent {
  subject: string;
  comment: string;
  priority: string;
  type: string;
  include_client: boolean;
  allowScreenshot: boolean = false;

  @ViewChild('file', {static: true}) file;

  constructor( private viewCtrl: ModalController,
               private zendesk: ZendeskProvider,
               public clientService: ClientService,
               private photo: PhotoService,
               private global: GlobalsService ) {

    console.log(this)
  }

  submitForm() {
    let ticket = {
      subject: this.subject,
      comment: this.comment,
      priority: this.priority,
      type: this.type
    }

    this.zendesk.createTicket(ticket, this.include_client).subscribe(
      () => this.dismiss(),
      () => this.global.handleResponse("Hmm... something went wrong.  Please email Jeremy a screenshot of this ticket")
    )
  }

  upload(file) {
    this.zendesk.uploadPhoto(file).subscribe(
      success => console.log(success),
      failure => console.log(failure),
      () => console.log('complete')
    )
  }

  uploadImage() {
    const file = this.file.nativeElement.files[0]
    let r = new FileReader()

    r.onload = (() => {
      let dataURL = r.result.toString().replace("data:image/jpeg;base64,/", "");
      this.upload(dataURL)
    });

    r.readAsDataURL(file);
  }

  dismiss() {
    this.viewCtrl.dismiss()
  }
}
